import { axiosInstance } from "@/api";

export interface AddressSuggestion {
	placeId: string;
	label: string;
}

export interface ResolvedAddress {
	formattedAddress: string;
	addressLine1: string;
	city: string;
	state: string;
	postalCode: string;
	countryCode: string;
}

export const addressLookupApi = {
	autocomplete: async (
		input: string,
		countryCode: string,
		sessionToken: string,
		signal?: AbortSignal,
	): Promise<AddressSuggestion[]> => {
		const response = await axiosInstance.get("/addresses/autocomplete", {
			params: { input, countryCode, sessionToken },
			signal,
		});
		return response.data.suggestions;
	},
	resolve: async (placeId: string, sessionToken: string): Promise<ResolvedAddress> => {
		const response = await axiosInstance.get(`/addresses/${encodeURIComponent(placeId)}`, {
			params: { sessionToken },
		});
		return response.data.address;
	},
};
